/*
 * Custom mega menu (delegated, re-render-safe)
 * The header re-renders its nav (overflow-list recalculation / hydration), which
 * detaches any nodes we'd bind listeners to. So instead of binding to specific
 * nodes, we delegate on `document` and resolve the trigger item by its handleised
 * label at event time — always operating on the live DOM.
 *
 * Each <custom-mega-menu> panel carries data-trigger (a handle). On hover/focus of
 * the matching header nav link the panel opens (positioned under the header) and
 * the theme's native submenu is suppressed via CSS (see the section stylesheet).
 * Closes on mouse-leave, outside click, or Escape.
 */
(function () {
  'use strict';

  function handleize(value) {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  var panels = []; // { el, trigger, timer, link }

  function collect() {
    document.querySelectorAll('custom-mega-menu').forEach(function (el) {
      if (el.dataset.cmmReady === '1') return;
      var trigger = el.getAttribute('data-trigger');
      if (!trigger) return;
      el.dataset.cmmReady = '1';
      panels.push({ el: el, trigger: trigger, timer: null, link: null });
    });
  }

  function getHeader() {
    return (
      document.querySelector('#header-component') ||
      document.querySelector('.header-section') ||
      document.querySelector('.header')
    );
  }

  function panelForLink(link) {
    var label = link.querySelector('.menu-list__link-title') || link;
    var h = handleize(label.textContent);
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].trigger === h) return panels[i];
    }
    return null;
  }

  function panelByEl(el) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].el === el) return panels[i];
    }
    return null;
  }

  function position(p) {
    var header = getHeader();
    if (header) {
      p.el.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
    }
  }

  function cancelClose(p) {
    if (p.timer) {
      clearTimeout(p.timer);
      p.timer = null;
    }
  }

  function closeNow(p) {
    p.el.classList.remove('is-open');
    if (p.link) {
      p.link.classList.remove('menu-list__link--active');
      p.link.setAttribute('aria-expanded', 'false');
    }
  }

  function deferClose(p) {
    cancelClose(p);
    p.timer = setTimeout(function () {
      closeNow(p);
    }, 180);
  }

  function open(p, link) {
    cancelClose(p);
    // Only one custom panel open at a time.
    panels.forEach(function (other) {
      if (other !== p) closeNow(other);
    });
    if (link) {
      p.link = link;
      link.classList.add('menu-list__link--active');
      link.setAttribute('aria-expanded', 'true');
      var item = link.closest('.menu-list__list-item');
      if (item) item.classList.add('has-custom-mega-menu');
    }
    position(p);
    p.el.classList.add('is-open');
  }

  function onOver(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('.menu-list__link');
    if (link) {
      var p = panelForLink(link);
      if (p) open(p, link);
      return;
    }

    var panelEl = target.closest('custom-mega-menu');
    if (panelEl) {
      var pp = panelByEl(panelEl);
      if (pp) cancelClose(pp);
    }
  }

  function onOut(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('.menu-list__link');
    if (link) {
      var p = panelForLink(link);
      if (p) deferClose(p);
      return;
    }

    var panelEl = target.closest('custom-mega-menu');
    if (panelEl) {
      var pp = panelByEl(panelEl);
      if (pp) deferClose(pp);
    }
  }

  function onFocusIn(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('.menu-list__link');
    if (link) {
      var p = panelForLink(link);
      if (p) {
        open(p, link);
        return;
      }
    }

    if (target.closest('custom-mega-menu')) return;

    // Focus moved outside any trigger/panel — close everything.
    panels.forEach(deferClose);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') panels.forEach(closeNow);
  }

  function onClick(event) {
    panels.forEach(function (p) {
      if (!p.el.classList.contains('is-open')) return;
      if (p.el.contains(event.target)) return;
      var item = p.link ? p.link.closest('.menu-list__list-item') : null;
      if (item && item.contains(event.target)) return;
      closeNow(p);
    });
  }

  function reposition() {
    panels.forEach(function (p) {
      if (p.el.classList.contains('is-open')) position(p);
    });
  }

  function init() {
    collect();
  }

  document.addEventListener('mouseover', onOver);
  document.addEventListener('mouseout', onOut);
  document.addEventListener('focusin', onFocusIn);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('click', onClick);
  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, { passive: true });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
